export default "__VITE_ASSET__e9d9e2ec__"